const config = new Map();

config.set("OYF_API_URL", process.env.VUE_APP_BM_API_URL + "/api");
let cookieDomain = process.env.AUTH_DOMAIN || window.location.hostname;
config.set("COOKIE_SETTINGS", {
  domain: cookieDomain,
  secure: window.location.protocol === "https:"
});

export default config;
